import React from 'react';
import { Navigate } from 'react-router-dom';

import { isAuthenticated } from '../utils/auth';
import { urls } from '../urls';
import { useSidebarVisibility } from '../utils/app-shell';

export function Protected({ ...props }) {
  if (!isAuthenticated()) {
    return <Navigate to={urls.login} />;
  }

  return <Public {...props} />;
}

export function Public({ component: PageComponent, ...props }) {
  useSidebarVisibility(props);

  return <PageComponent {...props} />;
}
